import { render, staticRenderFns } from "./CompetitionListUserLayout.vue?vue&type=template&id=5bc9b450&scoped=true&"
import script from "./CompetitionListUserLayout.vue?vue&type=script&lang=js&"
export * from "./CompetitionListUserLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9b450",
  null
  
)

export default component.exports